import { useMemo } from "react";
import { buildCalendarEvents } from "@/components/calendar/views/buildCalendarEvents";
import { groupEventsByDay } from "@/lib/calendar/mobile-agenda";
import type { AppointmentWithDetails, Veterinarian } from "@/hooks/useAppointments";
import { useTranslation } from "react-i18next";

export function useMobileAgendaEvents(
  appointments: AppointmentWithDetails[],
  professionals: Veterinarian[],
) {
  const { t } = useTranslation("calendar");
  const professionalsById = useMemo(
    () => new Map(professionals.map((p) => [p.id, p])),
    [professionals],
  );
  const events = useMemo(
    () => buildCalendarEvents(appointments, { professionalsById, t }),
    [appointments, professionalsById, t],
  );
  const grouped = useMemo(() => groupEventsByDay(events), [events]);
  return { events, grouped };
}
